import type { AnySchema, ValidationError } from 'joi';
import Joi from 'joi';

export const joi: typeof Joi & {
  commaDelimitedStringArray: (typeof Joi)['array'];
} = Joi.extend((j) => ({
  base: j.array(),
  coerce: (value) => ({
    value: value.split ? value.split(',').filter(Boolean) : value,
  }),
  type: 'commaDelimitedStringArray',
}));

type CreateValidatorOptions<TError extends Error> = {
  errorFactory(err: ValidationError): TError;
};

export const createValidator =
  // oxlint-disable-next-line typescript/unbound-method -- FIXME: pre-existing error: Avoid referencing unbound methods which may cause unintentional scoping of `this`.
  <TError extends Error>({ errorFactory }: CreateValidatorOptions<TError>) =>
    <T>(schema: AnySchema) =>
    (x: unknown) => {
      const { error: err, value } = schema.validate(x);
      if (err) {
        throw errorFactory(err);
      }
      return value as T;
    };
